import React, { useEffect, useState } from 'react'
import { StatusList } from '../constants'
import { useParams } from 'react-router-dom'
import { CheckinOutAttendeeWithType } from 'types/event/eventAttendance'
import {
  useAcceptCheckInRequest,
  useCheckInParticipantDirectly,
  useCheckoutParticipantDirectly,
  useUndoCheckoutParticipantDirectly,
} from 'api/Event/Attendance'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { ArrowCounterClockwise } from '@phosphor-icons/react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { convertToUtc } from 'helper/utility'
import { failureMessage } from 'api/global'

const StatusLabelNone = ({
  participant,
  recentlyCheckedInOut,
  setRecentlyCheckedInOut,
}: {
  participant: CheckinOutAttendeeWithType
  recentlyCheckedInOut: string[]
  setRecentlyCheckedInOut: React.Dispatch<React.SetStateAction<string[]>>
}) => {
  const { id }: { id: string } = useParams()
  const { selectedDate } = eventAttendanceStore(store => ({
    selectedDate: store.selectedDate,
  }))
  const {
    mutate: checkInParticipantDirectMutation,
    isLoading: checkinParticipantDirectLoading,
  } = useCheckInParticipantDirectly()
  const handleClickLabel = () => {
    if (convertToUtc(selectedDate) > convertToUtc(new Date())) {
      failureMessage('Cannot perfrom this action on future dates')
      return
    }
    const payload = {
      eventId: id,
      [`${participant.type}Id`]: participant._id,
      familyId: participant.familyId,
      // admissionTicket: participant.admissionTicket,
      admissionTicket: participant.ticket,
    }

    checkInParticipantDirectMutation(payload, {
      onSuccess: () => {
        setRecentlyCheckedInOut([...recentlyCheckedInOut, participant._id])
      },
    })
  }
  return (
    <>
      <div
        onClick={handleClickLabel}
        style={{
          backgroundColor: StatusList[0].color,
        }}
        className="flex flex-center justify-center px-15px py-10px radius-12 ml-15px pointer"
      >
        {checkinParticipantDirectLoading ? (
          <ButtonSpinner size={20} color="#000" />
        ) : (
          <>
            <img src={StatusList[0].img} alt={StatusList[0].value} />
            <h4 className="ml-10px text-12 w-600">{StatusList[0].title}</h4>
          </>
        )}
      </div>
    </>
  )
}

const StatusLabelPending = () => {
  return (
    <>
      <div
        style={{
          backgroundColor: StatusList[6].color,
        }}
        className="flex flex-center justify-center px-15px py-10px radius-12 pointer"
      >
        <img src={StatusList[6].img} alt={StatusList[6].value} />
        <h4 className="ml-10px text-12 w-600">{StatusList[6].title}</h4>
      </div>
    </>
  )
}

const StatusLabelCheckin = ({
  participant,
  recentlyCheckedInOut,
  setRecentlyCheckedInOut,
}: {
  participant: CheckinOutAttendeeWithType
  recentlyCheckedInOut: string[]
  setRecentlyCheckedInOut: React.Dispatch<React.SetStateAction<string[]>>
}) => {
  const [shwoundo, setShowUndo] = useState(false)
  const { selectedDate } = eventAttendanceStore(store => ({
    selectedDate: store.selectedDate,
  }))
  const {
    mutate: checkoutParticipantDirectMutation,
    isLoading: checkoutParticipantDirectLoading,
  } = useCheckoutParticipantDirectly()
  const handleClickLable = () => {
    if (convertToUtc(selectedDate) > convertToUtc(new Date())) {
      failureMessage('Cannot perfrom this action on future dates')
      return
    }
    const payload = {
      checkInId: participant.checkInId,
    }
    checkoutParticipantDirectMutation(payload, {
      onSuccess: () => {
        setRecentlyCheckedInOut([...recentlyCheckedInOut, participant._id])
      },
    })
  }

  const {
    mutate: undoCheckoutParticipantDirectMutation,
    isLoading: undoCheckInOutMutationLoading,
  } = useUndoCheckoutParticipantDirectly()

  const handleRevert = () => {
    setShowUndo(false)
    setRecentlyCheckedInOut(
      recentlyCheckedInOut.filter(item => item !== participant._id),
    )
    undoCheckoutParticipantDirectMutation(participant.checkInId)
  }

  useEffect(() => {
    if (recentlyCheckedInOut.includes(participant._id)) {
      setShowUndo(true)
    } else {
      setShowUndo(false)
    }
  }, [recentlyCheckedInOut, participant._id])

  useEffect(() => {
    const timer = setTimeout(() => {
      setRecentlyCheckedInOut(
        recentlyCheckedInOut.filter(item => item !== participant._id),
      )
      setShowUndo(false)
    }, 3000)

    return () => clearTimeout(timer)
  }, [recentlyCheckedInOut, participant._id])

  return (
    <div className="flex gap-10px">
      <div
        style={{
          backgroundColor: StatusList[3].color,
        }}
        className="flex flex-center justify-center px-15px py-10px radius-12 ml-15px pointer"
        onClick={handleClickLable}
      >
        {checkoutParticipantDirectLoading || undoCheckInOutMutationLoading ? (
          <ButtonSpinner size={20} color="#000" />
        ) : (
          <>
            <img src={StatusList[3].img} alt={StatusList[3].value} />
            <h4 className="ml-10px text-12 w-600">{StatusList[3].title}</h4>
          </>
        )}
      </div>
      {shwoundo && (
        <div
          className="flex flex-col justify-center align-center pointer"
          onClick={handleRevert}
        >
          <ArrowCounterClockwise size={20} color="#000" />
          <p>undo</p>
        </div>
      )}
    </div>
  )
}

const StatusLabelCheckout = ({
  participant,
  recentlyCheckedInOut,
  setRecentlyCheckedInOut,
}: {
  participant: CheckinOutAttendeeWithType
  recentlyCheckedInOut: string[]
  setRecentlyCheckedInOut: React.Dispatch<React.SetStateAction<string[]>>
}) => {
  const { id }: { id: string } = useParams()
  const [shwoundo, setShowUndo] = useState(false)
  const { selectedDate } = eventAttendanceStore(store => ({
    selectedDate: store.selectedDate,
  }))
  const {
    mutate: checkInParticipantDirectMutation,
    isLoading: checkinParticipantDirectLoading,
  } = useCheckInParticipantDirectly()
  const handleClickLabel = () => {
    // if (convertToUtc(new Date()) !== convertToUtc(selectedDate)) {
    //   failureMessage('Please select the current date to perform this action')
    //   return
    // }
    if (convertToUtc(selectedDate) > convertToUtc(new Date())) {
      failureMessage('Cannot perfrom this action on future dates')
      return
    }
    const payload = {
      eventId: id,
      [`${participant.type}Id`]: participant._id,
      familyId: participant.familyId,
      // admissionTicket: participant.admissionTicket,
      admissionTicket: participant.ticket,
    }

    checkInParticipantDirectMutation(payload, {
      onSuccess: () => {
        setRecentlyCheckedInOut([...recentlyCheckedInOut, participant._id])
      },
    })
  }
  const {
    mutate: undoCheckoutParticipantDirectMutation,
    isLoading: undoCheckInOutMutationLoading,
  } = useUndoCheckoutParticipantDirectly()

  const handleRevert = () => {
    setShowUndo(false)
    setRecentlyCheckedInOut(
      recentlyCheckedInOut.filter(item => item !== participant._id),
    )
    undoCheckoutParticipantDirectMutation(participant.checkInId)
  }

  useEffect(() => {
    if (recentlyCheckedInOut.includes(participant._id)) {
      setShowUndo(true)
    } else {
      setShowUndo(false)
    }
  }, [recentlyCheckedInOut, participant._id])

  useEffect(() => {
    const timer = setTimeout(() => {
      setRecentlyCheckedInOut(
        recentlyCheckedInOut.filter(item => item !== participant._id),
      )
      setShowUndo(false)
    }, 3000)

    return () => clearTimeout(timer)
  }, [recentlyCheckedInOut, participant._id])

  return (
    <div className="flex gap-10px">
      <div
        style={{
          backgroundColor: StatusList[4].color,
        }}
        className="flex flex-center justify-center px-15px py-10px radius-12 ml-15px pointer"
        onClick={handleClickLabel}
      >
        {checkinParticipantDirectLoading || undoCheckInOutMutationLoading ? (
          <ButtonSpinner size={20} color="#000" />
        ) : (
          <>
            <img src={StatusList[4].img} alt={StatusList[4].value} />
            <h4 className="ml-10px text-12 w-600">{StatusList[4].title}</h4>
          </>
        )}
      </div>
      {shwoundo && (
        <div
          className="flex flex-col justify-center align-center pointer"
          onClick={handleRevert}
        >
          <ArrowCounterClockwise size={20} color="#000" />
          <p>undo</p>
        </div>
      )}
    </div>
  )
}

const StatusLabelDroppedIn = () => {
  return (
    <div
      style={{
        backgroundColor: StatusList[2].color,
      }}
      className="flex flex-center justify-center px-15px py-10px radius-12 ml-15px"
    >
      <img src={StatusList[1].img} alt={StatusList[1].value} />
      <h4 className="ml-10px text-12 w-600">{StatusList[1].title}</h4>
    </div>
  )
}

const StatusLabelDroppedOut = () => {
  return (
    <div
      style={{
        backgroundColor: StatusList[2].color,
      }}
      className="flex flex-center justify-center px-15px py-10px radius-12 ml-15px"
    >
      <img src={StatusList[2].img} alt={StatusList[2].value} />
      <h4 className="ml-10px text-12 w-600">{StatusList[2].title}</h4>
    </div>
  )
}

const StatusLabelCheckinPending = ({
  participant,
  recentlyCheckedInOut,
  setRecentlyCheckedInOut,
}: {
  participant: CheckinOutAttendeeWithType
  recentlyCheckedInOut: string[]
  setRecentlyCheckedInOut: React.Dispatch<React.SetStateAction<string[]>>
}) => {
  const { id }: { id: string } = useParams()
  const [shwoundo, setShowUndo] = useState(false)
  const { selectedDate } = eventAttendanceStore(store => ({
    selectedDate: store.selectedDate,
  }))
  const {
    mutate: checkInRequestedDirectMutation,
    isLoading: checkInRequestedDirectMutationtLoading,
  } = useAcceptCheckInRequest()
  const handleClickLabel = () => {
    if (convertToUtc(selectedDate) > convertToUtc(new Date())) {
      failureMessage('Cannot perfrom this action on future dates')
      return
    }
    const payload = {
      checkInId: participant.checkInId,
    }

    checkInRequestedDirectMutation(payload, {
      onSuccess: () => {
        setRecentlyCheckedInOut([...recentlyCheckedInOut, participant._id])
      },
    })
  }
  const {
    mutate: undoCheckoutParticipantDirectMutation,
    isLoading: undoCheckInOutMutationLoading,
  } = useUndoCheckoutParticipantDirectly()

  const handleRevert = () => {
    setShowUndo(false)
    setRecentlyCheckedInOut(
      recentlyCheckedInOut.filter(item => item !== participant._id),
    )
    undoCheckoutParticipantDirectMutation(participant.checkInId)
  }

  useEffect(() => {
    if (recentlyCheckedInOut.includes(participant._id)) {
      setShowUndo(true)
    } else {
      setShowUndo(false)
    }
  }, [recentlyCheckedInOut, participant._id])

  useEffect(() => {
    const timer = setTimeout(() => {
      setRecentlyCheckedInOut(
        recentlyCheckedInOut.filter(item => item !== participant._id),
      )
      setShowUndo(false)
    }, 3000)

    return () => clearTimeout(timer)
  }, [recentlyCheckedInOut, participant._id])

  return (
    <div className="flex gap-10px">
      <div
        style={{
          backgroundColor: StatusList[7].color,
        }}
        className="flex flex-center justify-center px-15px py-10px radius-12 ml-15px pointer"
        onClick={handleClickLabel}
      >
        {checkInRequestedDirectMutationtLoading ? (
          <ButtonSpinner size={20} color="#000" />
        ) : (
          <>
            <img src={StatusList[7].img} alt={StatusList[7].value} />
            <h4 className="ml-10px text-12 w-600">{StatusList[7].title}</h4>
          </>
        )}
      </div>
      {shwoundo && (
        <div
          className="flex flex-col justify-center align-center pointer"
          onClick={handleRevert}
        >
          <ArrowCounterClockwise size={20} color="#000" />
          <p>undo</p>
        </div>
      )}
    </div>
  )
}

const StatusLabelCheckoutPending = ({
  participant,
  recentlyCheckedInOut,
  setRecentlyCheckedInOut,
}: {
  participant: CheckinOutAttendeeWithType
  recentlyCheckedInOut: string[]
  setRecentlyCheckedInOut: React.Dispatch<React.SetStateAction<string[]>>
}) => {
  const [shwoundo, setShowUndo] = useState(false)
  const { selectedDate } = eventAttendanceStore(store => ({
    selectedDate: store.selectedDate,
  }))
  const {
    mutate: checkoutParticipantDirectMutation,
    isLoading: checkoutParticipantDirectLoading,
  } = useCheckoutParticipantDirectly()
  const {
    mutate: undoCheckoutParticipantDirectMutation,
    isLoading: undoCheckInOutMutationLoading,
  } = useUndoCheckoutParticipantDirectly()

  const handleClickLable = () => {
    if (convertToUtc(selectedDate) > convertToUtc(new Date())) {
      failureMessage('Cannot perfrom this action on future dates')
      return
    }
    const payload = {
      checkInId: participant.checkInId,
    }
    checkoutParticipantDirectMutation(payload, {
      onSuccess: () => {
        setRecentlyCheckedInOut([...recentlyCheckedInOut, participant._id])
      },
    })
  }

  const handleRevert = () => {
    setShowUndo(false)
    setRecentlyCheckedInOut(
      recentlyCheckedInOut.filter(item => item !== participant._id),
    )
    undoCheckoutParticipantDirectMutation(participant.checkInId)
  }

  useEffect(() => {
    if (recentlyCheckedInOut.includes(participant._id)) {
      setShowUndo(true)
    } else {
      setShowUndo(false)
    }
  }, [recentlyCheckedInOut, participant._id])

  useEffect(() => {
    const timer = setTimeout(() => {
      setRecentlyCheckedInOut(
        recentlyCheckedInOut.filter(item => item !== participant._id),
      )
      setShowUndo(false)
    }, 3000)

    return () => clearTimeout(timer)
  }, [recentlyCheckedInOut, participant._id])

  return (
    <div className="flex gap-10px">
      <div
        style={{
          backgroundColor: StatusList[5].color,
        }}
        className="flex flex-center justify-center px-15px py-10px radius-12 ml-15px pointer"
        onClick={handleClickLable}
      >
        {checkoutParticipantDirectLoading || undoCheckInOutMutationLoading ? (
          <ButtonSpinner size={20} color="#000" />
        ) : (
          <>
            <img src={StatusList[5].img} alt={StatusList[5].value} />
            <h4 className="ml-10px text-12 w-600">{StatusList[5].title}</h4>
          </>
        )}
      </div>
      {shwoundo && (
        <div
          className="flex flex-col justify-center align-center pointer"
          onClick={handleRevert}
        >
          <ArrowCounterClockwise size={20} color="#000" />
          <p>undo</p>
        </div>
      )}
    </div>
  )
}

export {
  StatusLabelNone,
  StatusLabelPending,
  StatusLabelCheckin,
  StatusLabelCheckout,
  StatusLabelDroppedIn,
  StatusLabelDroppedOut,
  StatusLabelCheckinPending,
  StatusLabelCheckoutPending,
}
